/*
 * Joyee nail sizing — 共享给三个产品页 block：
 *   Nail Length Guide / Nail Size Detail / Finger Size Adjustment
 * 之前三个 snippet 各自带一份相同的表和读取逻辑，同一个 bug 修了两遍，
 * 所以合并到这里。页面上只会执行一次（下面的 guard）。
 */
(function () {
  if (window.JoyeeNailSizing) return;

  /* 尺码值的 handle 是 xs/s/m/l，不随翻译变化，用它来认出哪个选项是尺码。 */
  var SIZE_KEYS = ['xs', 's', 'm', 'l'];
  var CUSTOM_RE = /custom|personnalis|benutzerdef|individualiz|individuell|personaliz|個性|カスタム/i;

  /* HANDLE_MAP — handle 直接映射到图片 key（快路径）。
     英文 handle 是默认语言，稳定不变。WORD_MAP 拆不了的非英文复合词
     （比如德语不带连字符的）也放这里。 */
  var HANDLE_MAP = {
    'medium-almond': 'almond-medium',
    'medium-stiletto': 'stiletto-medium',
    'medium-coffin': 'coffin-medium',
    'medium-oval': 'oval-medium',
    'medium-square': 'square-medium',
    'short-almond': 'almond-short',
    'short-coffin': 'coffin-short',
    'short-square': 'square-short',
    'short-stiletto': 'stiletto-short',
    'short-oval': 'oval-short',
    'extra-short-almond': 'almond-extra-short',
    'extra-short-coffin': 'coffin-extra-short',
    'extra-short-oval': 'oval-extra-short',
    'extra-short-square': 'square-extra-short',
    'extra-short-squoval': 'squoval-extra-short',
    'long-coffin': 'coffin-long',
    'long-stiletto': 'stiletto-long',
    'mitteloval': 'oval-medium'
  };

  /* WORD_MAP — 逐词翻译兜底，覆盖所有非英文语言。HANDLE_MAP 没命中时
     按连字符拆词逐个翻译，再拼回 {shape}-{length}，词序无所谓。 */
  var SHAPES = ['almond', 'coffin', 'oval', 'square', 'squoval', 'stiletto'];
  var WORD_MAP = {
    /* English passthrough */
    'almond': 'almond', 'coffin': 'coffin', 'oval': 'oval', 'square': 'square',
    'squoval': 'squoval', 'stiletto': 'stiletto', 'stileto': 'stiletto',
    'extra': 'extra', 'short': 'short', 'medium': 'medium', 'long': 'long',
    /* French */
    'amande': 'almond', 'ovale': 'oval', 'ballerine': 'coffin', 'carre': 'square', 'cercueil': 'coffin',
    'courte': 'short', 'court': 'short', 'moyenne': 'medium', 'moyen': 'medium', 'longue': 'long',
    /* German — base + inflected adjective forms */
    'mandel': 'almond', 'ballerina': 'coffin', 'eckig': 'square', 'quadratisch': 'square', 'quadrat': 'square',
    'kurz': 'short', 'kurze': 'short', 'kurzer': 'short', 'kurzes': 'short', 'kurzen': 'short',
    'mittel': 'medium', 'mittlere': 'medium', 'mittlerer': 'medium', 'mittleres': 'medium', 'mittleren': 'medium',
    'lang': 'long', 'lange': 'long', 'langer': 'long', 'langes': 'long', 'langen': 'long',
    /* Spanish — base + gender variants */
    'almendra': 'almond', 'ovalada': 'oval', 'ovalado': 'oval', 'bailarina': 'coffin', 'ataud': 'coffin',
    'cuadrada': 'square', 'cuadrado': 'square', 'estilete': 'stiletto',
    'corta': 'short', 'corto': 'short', 'media': 'medium', 'mediana': 'medium',
    'medio': 'medium', 'mediano': 'medium', 'larga': 'long', 'largo': 'long',
    'pequena': 'short', 'pequeno': 'short'
  };

  var cache = {};
  function resolveShapeKey(handle) {
    if (handle in cache) return cache[handle];
    if (HANDLE_MAP[handle]) return (cache[handle] = HANDLE_MAP[handle]);

    var words = handle.split('-');
    var shape = '', hasExtra = false, length = '';
    for (var i = 0; i < words.length; i++) {
      var eng = WORD_MAP[words[i]];
      if (!eng) continue;
      if (eng === 'extra') { hasExtra = true; continue; }
      if (SHAPES.indexOf(eng) !== -1) { shape = eng; continue; }
      if (eng === 'short' || eng === 'medium' || eng === 'long') { length = eng; }
    }
    if (!shape || !length) return (cache[handle] = null);
    return (cache[handle] = shape + '-' + (hasExtra ? 'extra-' : '') + length);
  }

  /* 选项的渲染形式由 section 的 picker_type 加 Dropdown 覆盖列表逐项决定，
     下拉和单选按钮都要读，只扫 <select> 会漏掉尺码。 */
  function readVariant() {
    var out = { sizeHandle: '', sizeText: '', isCustom: false, shapeHandle: '', shapeText: '', shapeId: '' };
    var fields = document.querySelectorAll('variant-selects select, variant-selects input[type="radio"]:checked');
    for (var i = 0; i < fields.length; i++) {
      var el = fields[i], handle, valueId;
      if (el.tagName === 'SELECT') {
        var opt = el.selectedOptions && el.selectedOptions[0];
        if (!opt) continue;
        handle = opt.dataset.handle || '';
        valueId = opt.dataset.valueId || '';
      } else {
        handle = el.dataset.handle || '';
        valueId = el.dataset.valueId || '';
      }
      handle = handle.trim().toLowerCase();
      if (!handle) continue;
      var text = (el.value || '').trim();

      if (SIZE_KEYS.indexOf(handle) !== -1) {
        out.sizeHandle = handle; out.sizeText = text;
      } else if (CUSTOM_RE.test(handle)) {
        out.isCustom = true; out.sizeText = text;
      } else if (resolveShapeKey(handle)) {
        out.shapeHandle = handle; out.shapeText = text; out.shapeId = valueId.trim();
      }
    }
    return out;
  }

  window.JoyeeNailSizing = {
    SIZE_KEYS: SIZE_KEYS,
    resolveShapeKey: resolveShapeKey,
    readVariant: readVariant
  };
})();
